import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppState } from '../../../store/app.state';
import { AuthActions } from '../../../store/state/auth/auth.actions';
import { ConnectivityActions } from '../../../store/state/connectivity/connectivity.actions';

@Component({
  selector: 'app-inactivity-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslatePipe,
  ],
  templateUrl: './inactivity-modal.component.html',
  styleUrls: ['./inactivity-modal.component.scss'],
})
export class InactivityModalComponent implements OnInit, OnDestroy {
  private dialogRef = inject(MatDialogRef<InactivityModalComponent>);
  private store$ = inject<Store<AppState>>(Store);
  private actions$ = inject(Actions);
  private data = inject<{ secondsLeft: number }>(MAT_DIALOG_DATA);
  private destroyRef = inject(DestroyRef);

  private counterInterval: ReturnType<typeof setInterval> | null = null;
  public secondsLeft = 0;

  public ngOnInit(): void {
    this.secondsLeft = Math.max(this.data.secondsLeft ?? 0, 0);

    this.counterInterval = setInterval(() => {
      this.secondsLeft = Math.max((this.secondsLeft ?? 0) - 1, 0);
      if (this.secondsLeft === 0) {
        this.store$.dispatch(AuthActions.logout({ msg: 'session expired' }));
        this.clearInterval();
        this.dialogRef.close(true);
      }
    }, 1000);

    this.actions$
      .pipe(ofType(AuthActions.logout), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.close());
  }

  public ngOnDestroy(): void {
    this.clearInterval();
  }

  public close(): void {
    this.clearInterval();
    this.store$.dispatch(ConnectivityActions.registerUserActivity());
    this.dialogRef.close(true);
  }

  private clearInterval(): void {
    if (this.counterInterval) {
      clearInterval(this.counterInterval);
      this.counterInterval = null;
    }
  }
}
